import React from 'react';
import PuffLoader from 'react-spinners/PuffLoader';
import {css} from '@emotion/react';

export default function PrimaryButton({
  buttonText,
  xPadding = 'px-5',
  yPadding = 'py-2',
  className = '',
  fontSize = 'text-sm',
  onClick,
  loading,
  color,
  loadColor = 'var(--color-primary)',
  background,
  differentBg,
  ...props
}) {
  const subDomainUser = localStorage.getItem('subdomain');
  const isProfiledRisk = subDomainUser?.includes('profiledrisk');

  const fontClass = isProfiledRisk ? 'font-sans' : '';

  const override = css`
    border-color: #ffffff;
    position: absolute;
    background: transparent;
    //left: 0;
    //right: 0;
  `;

  return (
    <button
      type={props?.type || 'button'}
      onClick={onClick}
      className={`${className} ${
        loading
          ? 'flex items-center justify-center relative bg-grey4 text-grey-200'
          : 'text-white'
      } ${
        differentBg ? differentBg : 'bg-brandBlue'
      } opacity-100 ${fontSize} font-normal max-h-12 primary_button flex items-center justify-center ${fontClass} hover:opacity-90 duration-200 transition rounded-lg ${xPadding} ${yPadding}`}
      style={{
        ...(color && !loading && {color}),
        ...(background && {background}),
        ...(props?.style && props.style),
      }}
      {...props}
    >
      {loading ? (
        <PuffLoader
          css={override}
          size={35}
          color={loadColor || color || '#ffffff'}
        />
      ) : null}
      <p>{buttonText}</p>
    </button>
  );
}
